import React from "react";
import styles from "./style.module.css";
import crossimage from "../../../assets/images/X.svg";
import BlitzLogo from "../../../assets/images/blitz_logo.svg";
import { useNavigate } from "react-router-dom";
import { useWhitelisting } from "../../../utils/hooks/useWhitelisting";

const Navbar = ({ logo, noLogo, title }) => {
  const navigate = useNavigate();
  let awb = JSON.parse(sessionStorage.getItem("awbNumber"));
  const { loading } = useWhitelisting();
  return (
    <div className={styles.navbarDesign}>
      {noLogo !== true && (
        <button
          className={styles.modalmobilebutton}
          onClick={() => navigate(`/`)}
        >
          {!loading && (
            <img
              src={logo || BlitzLogo}
              alt={"Logo"}
              onError={(e) => {
                // A brand logo URL that fails to load falls back to Blitz once.
                if (e.currentTarget.src !== BlitzLogo) e.currentTarget.src = BlitzLogo;
              }}
              className={styles.navbarLogo}
              width={130}
              height={50}
            />
          )}
        </button>
      )}
      {title !== undefined && (
        <div className={styles.navbarFeature}>
          <div>{title}</div>

          <button
            className={styles.modalmobilebutton}
            onClick={() => navigate(`/${awb}`)}
          >
            <div style={{ marginLeft: "70%" }}>
              <img src={crossimage} alt="crossimage" />
            </div>
          </button>
        </div>
      )}
    </div>
  );
};

export default Navbar;
